import * as types from "./constants";
import postsReducer from "../posts/reducers";
import { reduceReducers } from "../utils";

import update from 'immutability-helper';

const initialState = {
  objects: [],
  singlePostOptions: {
    visible: false
  },
  hydratingFeed: true
};

/*
  If we have an initial post then we want to render it as a modal.
  To do this, we need to push it into the initial state.
*/
if (window.initial_single_post_data) {
  initialState.singlePostOptions = {
    visible: true
  }
  if (window.initial_single_post_data.deleted) {
    initialState.singlePostOptions.deleted = true;
  } else {
    initialState.objects.unshift(
      window.initial_single_post_data
    );
  }
}

function activityFeedReducer(state=initialState, action) {
  let filtered;
  switch (action.type) {
    case types.ADD_FEED_POST:
      return update(state, {
        objects: {$unshift: [action.post]}
      });
    case types.ADD_FEED_POSTS:
      return update(state, {
        objects: {$push: ensureUniquePosts(action.objects)},
        cursor:  {$set:  action.cursor},
        more:    {$set:  action.more},
        hydratingFeed: {$set:  false}
      });
    case types.SET_SINGLE_POST_MODAL_VISIBLE:
      return update(state, {
        singlePostOptions: {
          visible: {$set: action.visible}
        }
      });
    default:
      return state;
  }
}

function ensureUniquePosts(posts) {
  // Ensure that posts are unique
  // since we prepend the single post modal data into the feed
  if (window.initial_single_post_data) {
    return posts.filter(function(obj) {
      return obj.id !== window.initial_single_post_data.id;
    });
  } else {
    return posts;
  }
}

const reducedActivityFeedReducer = reduceReducers(activityFeedReducer, postsReducer);

export default reducedActivityFeedReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/activity-feed/reducers.es6